export default {
  creditAppDeals: [],
  dealDetails: {},
  dealNotifications: {},
  hideReceipt: []
};